import { Card, Grid, TextField, InputLabel, Button } from '@mui/material';
import Dropdown from '../Components/Dropdown'
import DatePicker from '../Components/DatePicker'

export default function BookNow(props) {
    let mainColor = '#FF4D30'
    const cars = [
        { name: "Audi A1 S-Line" }, { name: "VW Golf 6" }, { name: "Toyota Camry" }, { name: "Honda Civic" }, { name: "BMW 320 Modern Line" }]
    const cities = [
        { name: "Seattle" }, { name: "Austin" }, { name: "New York" }, { name: "Los Angeles" }, { name: "Miami" }
    ]
    console.log(mainColor)
    return (
        <Card elevation={6} className={"book-content__box"} sx={{ m: 2 }}>
            <h2 style={{ marginBottom: 10 }}>Book Now</h2>
            <div className='line' style={{ marginBottom: 30 }} />
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                    <Dropdown label={"Select Car  "} options={cars} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Dropdown label={"Select Location  "} options={cities} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DatePicker label={"Pick Up Date"} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DatePicker label={"Drop Off Date"} />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Button contained fullWidth sx={{
                        backgroundColor: mainColor, color: 'white', py: 2, maxWidth: 400, '&:hover': {
                            backgroundColor: mainColor,
                            color: 'white',

                        }
                    }}>Book Now</Button>
                </Grid>
            </Grid>
        </Card>
    );
}